// extracted by mini-css-extract-plugin
module.exports = {"on":"selectUrl_on__w93_s","select":"selectUrl_select__-Em-4"};